<template>
  <div v-if="show" ref="chart" class="chart-content">
    <div class="chart-title">{{name}}</div>
    <i v-if="isShowCloseBtn" class="iconfont icon-guanbi_o chart-close" @click='close($event)' :class="{active: name !== ''}"></i>
    <el-table ref="myChart" :data="tableData" class="alarm" :cell-style="{ color: '#fff' }" style="margin-top:10px" :header-cell-style="{ color: '#d5dd2d',backgroundColor:'#063692'}" :row-class-name="tableRowClassName">>
      <!-- <el-table ref="myChart" :data="tableData" style="margin-top:10px" :row-class-name="tableRowClassName">> -->

      <template v-for="(item, index) in tableColumns">
        <el-table-column v-if="item.type=='date'" show-overflow-tooltip :min-width="item.width" :key="index" :prop="item.no" :label="item.name">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row[item.no]), item.dateFormatter) }}
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.type=='progress'" :min-width="item.width" :key="index" :prop="item.no" :label="item.name">
          <template slot-scope="scope">
            <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(scope.row[item.number], scope.row[item.totalNumber])" color="#42b983" />
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.type=='text'" show-overflow-tooltip :min-width="item.width" :key="index" :prop="item.no" :label="item.name">
          <template slot-scope="scope">
            {{item.formatter ? item.formatter(scope.row) : scope.row[item.no]}}
          </template>
        </el-table-column>
      </template>
      <!-- <el-table-column prop="createdTime" min-width="110" label="日期">
        <template slot-scope="scope">
          {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d}") }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip min-width="100" prop="no" label="单号"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="100" prop="productName" label="产品名称"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="100" prop="specName" label="规格型号"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="100" prop="manufacturerName" label="生产厂家"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="80" prop="orderNumber" label="接单数量"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="100" prop="finishNumber" label="已完成数量"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="80" prop="status" label="完成情况">
        <template slot-scope="scope">
          <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(scope.row.finishNumber, scope.row.orderNumber)" color="#42b983" />
        </template>
      </el-table-column> -->

    </el-table>
  </div>
</template>


<script>
import elementResizeDetectorMaker from "element-resize-detector";
// import {
//   GetPurchaseFinishStatus
// } from '@/api'
import BaseReportMixin from '@/mixin/baseReport-mixin.js'
import { EleResize } from '@/utils/EleResize.js'
export default ({
  mixins: [BaseReportMixin],
  data () {
    return {
      myChart: null,
      option: {},
      tableData: [],
      allData: [],
      show: true,
      totalPage: 0,
      pageSize: 12,
      pageIndex: 1,
      interval: 5 * 1000,
      setInterval: null
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    getDataAction: {
      type: Function,
      default () {
        return null
      }
    },
    tableColumns: {
      type: Array,
      default () {
        return []
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
    data: {
      handler (newVal, oldVal) {
        this.option.series[0].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    }
  },
  methods: {
    // 获取列表
    getData () {
      this.getDataAction({})
        .then(res => {
          this.allData = res.returnData
          // this.totalPage = Math.ceil(this.allData.length / this.pageSize)
          this.totalPage = this.allData.length
          this.tableData = this.getPaginationData(this.allData, this.pageIndex, this.pageSize)
          // console.log(this.data)
          // this.myChart.setOption(this.option);
          // this.init(res.returnData)
        })
    },
    getPaginationData (list, pageIndex, pageSize) {
      // return list ? list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize) : []
      return list ? list.slice(pageIndex - 1, pageSize + pageIndex - 1) : []
      // 0-10  1-11
    },
    init () {
      // this.myChart.setOption(this.option);

      // // 随窗口的大小变化自适应
      // window.addEventListener("resize", function () {
      //   myChart.resize();
      // });
      //  随外层div的大小变化自适应
      // const _this = this
      // let erd = elementResizeDetectorMaker();
      // erd.listenTo(this.$refs.myChart, (e) => {
      //   _this.$nextTick(() => {
      //     //_this.myChart.resize();
      //   })
      // })
      EleResize.on(this.$refs['chart'], (e) => {
        // console.log(e.target.innerHeight, 'e')
        // console.log(this.$refs['chart'].parentNode, 'this.$refs')
        this.$emit('SizeChange', e.target.innerWidth, e.target.innerHeight, this.$refs['chart'].parentNode.id)
      })
    },
    close (e) {
      console.log(e);
      
      this.show = false
      clearInterval(this.setInterval)
      // 给drag+index div 追加隐藏样式 e.path[2] = drag2 非动态获取

      e.target.parentNode.parentNode.classList.add('hide')

      
      // e.path[2].classList.add('hide');
      //修改state=0
      this.$emit('StateChange', 0, e.target.parentNode.parentNode.id);
    },
    tableRowClassName ({ row, rowIndex }) {

      if (rowIndex % 2 == 0) {
        // console.log(111, rowIndex, "rowIndex");
        return 'warning-row';
      } else if (rowIndex === 3) {
        // console.log(222, rowIndex, "rowIndex");
        return 'success-row';
      } else {
        return 'success-row';
      }
      return '';
    }
  },
  mounted () {
    this.getData();
    this.init()
    let that = this
    this.setInterval = setInterval(function () {
      that.pageIndex++;
      if (that.pageIndex > that.totalPage) {
        that.pageIndex = 1
        that.getData()
      }
      else {
        that.tableData = that.getPaginationData(that.allData, that.pageIndex, that.pageSize)
      }
    }, this.interval)
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
    clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
.chart-content {
  width: calc(100% - 20px);
  height: 100%;
  padding: 0 10px 10px;
  // display: flex;
  .chart {
    width: 100%;
    height: 100%;
    // position: absolute;
  }
  .chart-title {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
  .chart-close {
    height: 20px;
    width: 20px;
    color: rgb(255, 255, 255);
    margin-left: 20px;
    float: right;
   
    // margin-top: -19px;
    &.active {
      z-index: 999 !important;
      margin-top: -19px;
    }
  }
}

// 完成情况百分比数字的颜色
/deep/ .el-progress-bar__innerText {
  color: #1e377b;
}

/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}
// /* 表格内背景颜色 */
// ::v-deep .el-table th,
// ::v-deep .el-table tr,
// ::v-deep .el-table td {
//   background-color: transparent !important;
// }
::v-deep .el-table__header-wrapper {
  margin-bottom: 0px !important;
}
/deep/ .el-table tbody tr {
  pointer-events: none; // 去掉选中高亮
}
/deep/ .el-table__cell {
  border: 0px !important; // 去掉表格内下划线
}
/deep/ .el-table__body {
  border-top: 0px !important; //删除表头下横线
}
/deep/ .el-table .warning-row {
  background: #01014d; // rgb(99, 130, 225);
}
// table 表格 index =1 的颜色
/deep/.el-table .success-row {
  background: #1e377b;
}
</style>
